import brandCardType from 'constants/aggregator/brandCard'

import ameximg from 'assets/images/american_express.png';
import maestroimg from 'assets/images/maestro.png';
import visaimg from 'assets/images/visa.png';
import mastercardimg from 'assets/images/mastercard.png';
import diners_club_international from 'assets/images/diners_club_international.png';
import discover from 'assets/images/discover.png';
import dk from 'assets/images/dk.png';
import jcb from 'assets/images/jcb.png';
import laser from 'assets/images/laser.png';
import placeHolder from 'assets/images/Place-holder.png';
import visa_electron from 'assets/images/visa_electron.png';

const getBrandImage = (brandCard) =>  {
    const types = {
        [brandCardType.MASTERCARD]: mastercardimg,
        [brandCardType.VISA]: visaimg,
        [brandCardType.MAESTRO]: maestroimg,
        [brandCardType.INTERNATIONAL]: diners_club_international,
        [brandCardType.JCB]: jcb,
        [brandCardType.DANKORT]: dk,
        [brandCardType.VISAELEC]: visa_electron,
        [brandCardType.LASER]: laser,
        [brandCardType.DISCOVER]: discover,
        [brandCardType.AMEX]: ameximg
    }

    return types[(brandCard || "").toLowerCase()] || placeHolder
}

export {
	getBrandImage
}